<div class="p-6 bg-primary-container min-h-screen">
  <div class="flex items-center mb-6">
    <button matIconButton (click)="goBack()" class="mr-4" aria-label="戻る">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="text-2xl font-bold m-0 text-on-primary-container">センサー管理: {{ siteName() }}</h1>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- 紐付け済みセンサー -->
    <mat-card>
      <mat-card-header class="pb-4">
        <mat-card-title>紐付け済みセンサー</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="pt-4">
        @if (assignedSensors().length === 0) {
          <p class="text-gray-500 text-center py-4">紐付けされたセンサーはありません</p>
        } @else {
          <div class="flex flex-col gap-4">
            @for (sensor of assignedSensors(); track sensor.id) {
              <div class="flex justify-between items-center p-4 border rounded-lg bg-white">
                <div>
                  <div class="font-bold text-lg">{{ sensor.categoryName }}</div>
                  <div class="text-sm text-gray-500">ID: {{ sensor.id }}</div>
                  <div class="text-sm text-gray-700">設置場所: {{ sensor.positionName || '未設定' }}</div>
                </div>
                <div class="flex gap-2">
                  <button matButton (click)="editPositionName(sensor)">編集</button>
                  <button matButton="tonal" (click)="unassign(sensor.id)">解除</button>
                </div>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>

    <!-- 未割り当てセンサー -->
    <mat-card>
      <mat-card-header class="pb-4">
        <mat-card-title>未割り当てセンサー</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="pt-4">
        @if (unassignedSensors().length === 0) {
          <p class="text-gray-500 text-center py-4">未割り当てのセンサーはありません</p>
        } @else {
          <div class="flex flex-col gap-4">
            @for (sensor of unassignedSensors(); track sensor.id) {
              <div class="flex justify-between items-center p-4 border rounded-lg bg-white">
                <div>
                  <div class="font-bold text-lg">{{ sensor.categoryName }}</div>
                  <div class="text-sm text-gray-500">ID: {{ sensor.id }}</div>
                </div>
                <button matButton 
                        [disabled]="!canAssign(sensor.categoryName)"
                        (click)="assign(sensor.id, sensor.categoryName)">
                  追加
                </button>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
